import React, { useState, useEffect } from "react";
import Images from "../../utils/images";
import { authorizedGet, authorizedPost } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";
import MessageBar, {
  config,
  DOBASEURLDOCUMENT,
  errorNotify,
  successNotify,
} from "../../utils/helper";
import Spinner from "../Spinner/Spinner";
import { TbShieldLock } from "react-icons/tb";
import { VscGistSecret } from "react-icons/vsc";
import { useLocation, useNavigate } from "react-router-dom";
import RejectModel from "../RejectModel/RejectModel";

const ViewQuestionnaire = ({
  userId,
  requestedUserId,
  questionnaireData,
  userData,
}) => {
  const [isAcceptedLoading, setIsAcceptedLoading] = useState(false);
  const [isRejectedLoading, setIsRejectedLoading] = useState(false);
  const [buttonStatus, setButtonStatus] = useState(null);
  const [requestLoading, setRequestLoading] = useState(false);
  const [horoscopeChecked, setHoroscopeChecked] = useState(false);
  const [isCommentSectionOpen, setIsCommentSectionOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const localStorageUserData = JSON.parse(localStorage.getItem("userData"));
  const userRole = localStorageUserData?.role;
  const [mutualApprovalStatus, setMutualApprovalStatus] = useState(
    questionnaireData?.[0]?.mutualApproval,
  );
  const [finalAgreeChecked, setFinalAgreeChecked] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    if (
      questionnaireData?.[0]?.adminApproval === "pending" ||
      questionnaireData?.[0]?.adminApproval === "approved"
    ) {
      setHoroscopeChecked(true);
      setFinalAgreeChecked(true);
    }
  }, []);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setHoroscopeChecked(isChecked);
  };
  const handleIsAgreeCheckboxChange = (e) => {
    const agreeChecked = e.target.checked;
    setFinalAgreeChecked(agreeChecked);
  };

  const handleSentRequest = async () => {
    if (!horoscopeChecked) {
      errorNotify("Please check the horoscope before sending the request.");
      return;
    }
    if (!finalAgreeChecked) {
      errorNotify("Please check the questionaire before sending the request.");
      return;
    }
    setRequestLoading(true);
    try {
      const data = {
        userId: userId,
        requestedUserId: requestedUserId,
        horoscope: true,
        isAgreed: true,
      };
      const res = await authorizedPost(
        configuration.apis.sendApproval,
        data,
        config,
      );
      const response = res?.data;
      if (response?.status) {
        successNotify(response?.message);
        setButtonStatus("Pending.....!");
      } else {
        errorNotify(response?.message);
      }
    } catch (error) {
      console.log(error);
      errorNotify("Unexpected Error");
    } finally {
      setRequestLoading(false);
    }
  };

  const handleAction = async (decision) => {
    if (decision === "approve") {
      setIsAcceptedLoading(true);
    } else {
      setIsRejectedLoading(true);
    }

    try {
      const data = {
        reqId: questionnaireData?.[0]?._id,
        action: decision,
        comments: comment,
      };
      const res = await authorizedPost(
        configuration.apis.overAllApproval,
        data,
        config,
      );

      if (res?.data?.status) {
        successNotify(res?.data?.message);
        if (decision === "approve") {
          setButtonStatus("approved");
          setMutualApprovalStatus("approved");
        }
        if (decision === "reject") {
          setButtonStatus("rejected");
        }
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (error) {
      errorNotify("Error processing request.");
    } finally {
      setIsAcceptedLoading(false);
      setIsRejectedLoading(false);
      setIsBlocked(false);
    }
  };

  const handleDeny = () => {
    setIsCommentSectionOpen(true);
  };

  const handleNoteChange = (event) => {
    setError(false);
    setComment(event.target.value);
  };

  const closeModal = () => {
    setComment("");
    setError(false);
    setIsCommentSectionOpen(false);
  };

  const handleSaveComment = () => {
    if (comment.length < 15) {
      setError(true);
    } else {
      handleAction("reject");
      setIsCommentSectionOpen(false);
      setError(false);
      setComment("");
    }
  };

  const location = useLocation();
  const pathName = location.pathname;
  const getPath = pathName.split("/");

  const questionaireLink = userData?.profile?.questionnaire?.questionLink;

  return (
    <div className="flex flex-wrap justify-center gap-4 p-4 md:justify-start">
      {userRole === "user" && getPath[1] !== "accepted-users" && (
        <label className="mb-2 flex items-center">
          <input
            type="checkbox"
            className="mr-2"
            checked={horoscopeChecked}
            onChange={handleCheckboxChange}
          />
          I have successfully completed my horoscope, thoroughly analyzing my
          birth chart and astrological details or not interested in matching
          horoscope.
        </label>
      )}
      {userRole === "user" && getPath[1] !== "accepted-users" && (
        <label className="mb-2 flex items-center">
          <input
            type="checkbox"
            className="mr-2"
            checked={finalAgreeChecked}
            onChange={handleIsAgreeCheckboxChange}
          />
          I agree to share the information provided in my questionnaire with
          other users for review and compatibility purposes.
        </label>
      )}
      <div
        className={`relative flex w-full flex-col items-center justify-center gap-2`}
      >
        {questionnaireData?.[0]?.questionnaire || questionaireLink ? (
          <embed
            src={
              DOBASEURLDOCUMENT +
                (questionnaireData?.[0]?.questionnaire || questionaireLink) ||
              require("../../Assets/sampleQuestions.pdf#toolbar=0")
            }
            className={`h-[80vh] w-full ${
              questionnaireData?.[0]?.adminApproval === "approved" ||
              userRole === "admin" ||
              userRole === "superAdmin"
                ? questionnaireData?.[0]?.otherUsersApproval?.status ===
                    "rejected" ||
                  questionnaireData?.[0]?.mutualApproval === "rejected" ||
                  buttonStatus === "rejected"
                  ? "blur-md"
                  : ""
                : "blur-md"
            }`}
            type="application/pdf"
          />
        ) : (
          <p className="text-center text-lg text-gray-600">
            Questionnaire not available.
          </p>
        )}

        {/* Condition for non-admin*/}
        {questionnaireData?.[0]?.adminApproval !== "approved" &&
          userRole === "user" && (
            <div className="absolute z-10 flex h-[80vh] w-full flex-col items-center justify-center">
              {questionnaireData?.[0]?.adminApproval === "pending" ||
              questionnaireData?.[0]?.adminApproval === "rejected" ||
              buttonStatus ? (
                <button className="z-40 rounded-md bg-textYellow px-10 py-2 text-white">
                  {buttonStatus === null ? (
                    <p>{questionnaireData?.[0]?.adminApproval}.....!</p>
                  ) : (
                    <p>{buttonStatus}</p>
                  )}
                </button>
              ) : (
                <>
                  {userRole === "user" && (
                    <>
                      <button
                        onClick={handleSentRequest}
                        className={`z-40 rounded-md bg-textYellow px-10 py-2 text-white ${!(horoscopeChecked && finalAgreeChecked) ? "cursor-not-allowed opacity-50" : ""}`}
                        disabled={!(horoscopeChecked && finalAgreeChecked)}
                      >
                        {requestLoading ? <Spinner /> : "Questionnaire Request"}
                      </button>
                      <p className="text-xs text-red-600">
                        Note: Raise Request to see the Questionnaire
                      </p>
                    </>
                  )}
                </>
              )}
            </div>
          )}
        {questionnaireData?.[0]?.adminApproval === "approved" &&
          getPath[1] !== "accepted-users" && (
            <>
              {questionnaireData?.[0]?.otherUsersApproval?.status ===
                "rejected" ||
              mutualApprovalStatus === "rejected" ||
              buttonStatus === "rejected" ? (
                <div>
                  <button className="flex items-center justify-center rounded-sm bg-red-600 p-2 text-white">
                    Request Was Declined
                  </button>
                </div>
              ) : (
                <div className="flex w-full items-center justify-around">
                  {mutualApprovalStatus === "approved" ? (
                    <div className="flex items-center justify-center">
                      <button
                        disabled
                        className="cursor-not-allowed rounded bg-green-600 px-4 py-2 text-white"
                      >
                        Approved
                      </button>
                    </div>
                  ) : (
                    <div className="flex w-full items-center justify-around">
                      <button
                        onClick={() => handleAction("approve")}
                        disabled={isAcceptedLoading}
                        className="rounded bg-green-500 px-4 py-2 text-white hover:bg-green-600"
                      >
                        {isAcceptedLoading ? "Approving..." : "Accept"}
                      </button>
                      <button
                        onClick={handleDeny}
                        disabled={isRejectedLoading}
                        className="rounded bg-red-500 px-4 py-2 text-white hover:bg-red-600"
                      >
                        {isRejectedLoading ? "Declining..." : "Deny"}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
      </div>

      {isCommentSectionOpen && (
        <div className="popup-container fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
          <RejectModel
            setComment={setComment}
            comment={comment}
            handleNoteChange={handleNoteChange}
            closeModal={closeModal}
            error={error}
            handleSaveComment={handleSaveComment}
            setIsBlocked={setIsBlocked}
            isShowDropdown={false}
          />
        </div>
      )}
      <MessageBar />
    </div>
  );
};

export default ViewQuestionnaire;
